// type Phase_D = {
//     step:  string;
//     title: string;
//     text:  string[];
// };

// type Phase_E = {
//     step:        string;
//     title:       string;
//     description: string;
//     text:        string[];
// };

// type Phase_B = {
//     step: string;
//     expectations:
//         {
//             id:      string;
//             heading: string;
//             benchmarks:
//                 {
//                     id:   string;
//                     text: string;
//                     subBenchmarks: 
//                         {
//                             id:              string;
//                             phase:           object;
//                             checklistItems:  string[];
//                             feedback:        string;
//                             type:            string;
//                         }[];
//                 }[];
//         }[];
// };

// type Phase_R = {
//     step:    string;
//     slides:  string[] | { text: { __html: string; linkHoverText: object; }}[];
// };

// type Phase_F = {
//     step:      string;
//     title:     string;
//     heading:   string;
//     questions: string;
// };

// type Step_Data = [Phase_D, Phase_E, Phase_B, Phase_R, Phase_F];

// export const STEP_DATA: Step_Data = [

    import {link, para, text} from "./utils";

    export const C5CA_PhaseDEBRF = [
        {
            step: "D",
            title: "Define Rules:",
            text: ["The purpose of this debriefing is to reflect on the scenario you have just completed in order to help you improve your skills as a paramedic.  It is not meant to assess your overall abilities as a paramedic.", "This debriefing will summarize the learning objectives of this scenario and the performance benchmarks (standards) for achieving each objective.  The system will then prompt you to examine differences between the treatment actions that you performed and those indicated by the clinical findings revealed during the scenario, or that would have been revealed by a more thorough assessment and reassessment of this patient.  Finally, it will prompt you to state some 'take home points' to improve your performance."]
        },
        {
            step: "E",
            title: "Explain the learning objectives:",
            description: "This scenario was designed to give you practice with:",
            text: [
                "Conducting a thorough trauma patient assessment",
                "Managing a potential head or spinal injury",
                "Managing severe external bleeding",
                "Managing inadequate breathing",
                "Managing hemorrhagic shock",
                "Making appropriate transport decisions",
                "Performing ongoing patient management and assessment",
            ]
        },
        {
            step: "B",
            expectations: [
                {
                    expectationText: "Conduct a thorough trauma assessment",
                    benchmarks: [
                        {
                            benchmarkText: "Before approaching patient, apply PPE, check that the scene is safe, determine the number of patients, and request additional help if necessary",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "On initial patient contact, form a general impression of the patient's condition, assess patient's level of consciousness, and identify apparent life threats",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "During the Primary Survey:",
                            subBenchmarks: 
                            [
                                "Check that airway is open, clear of fluids and foreign bodies, and has intact physical structures", 
                                "Listen for abnormal breath sounds and check breathing rate, rhythm, and quality", 
                                "Check circulation: pulse rate/rhythm/quality; skin color/temperature/condition; perform gross blood sweep",
                                "Determine the need for rapid transport",
                                "Trauma expose patient"
                            ]
                        },
                        {
                            benchmarkText: "Take baseline vitals and, if possible, obtain SAMPLE history and OPQRST",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Perform a rapid head-to-toe assessment (Secondary Survey), looking/listening/feeling for DCAP-BTLS and abnormal conditions at each body part (e.g., check neck for tracheal deviation and JVD).",
                            subBenchmarks: []
                        },
                    ]
                },
                {
                    expectationText: "Manage a potential spinal injury",
                    benchmarks: [
                        {
                            benchmarkText: "Take (or direct a partner to take) manual c-spine precautions.",
                            subBenchmarks: []
                        },
                    ]
                },
                {
                    expectationText: "Manage severe external bleeding",
                    benchmarks: [
                        {
                            benchmarkText: "Apply a tourniquet during the primary survey as far proximal to the wound as possible",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Confirm that bleeding has stopped and pulses are absent",
                            subBenchmarks: []
                        },
                    ]
                },
                {
                    expectationText: "Manage inadequate breathing",
                    benchmarks: [
                        {
                            benchmarkText: "Ventilate the patient using a BVM at a rate of 10-12 BPM",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Titrate oxygen to SpO2 of 95-99%",
                            subBenchmarks: []
                        },
                    ]
                },
                {
                    expectationText: "Manage hemorrhagic shock",
                    benchmarks: [
                        {
                            benchmarkText: "Administer high flow oxygen",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Place two large-bore IVs en route",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Bolus normal saline or Lactated Ringers to a goal BP of 90 mm Hg systolic as soon as possible",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Keep the patient warm by covering him with blankets, turning the heat up in the ambulance, applying heat packs, etc.",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Maintain patient in supine position",
                            subBenchmarks: []
                        },
                    ]
                },
                {
                    expectationText: "Make appropriate transport decisions",
                    benchmarks: [
                        {
                            benchmarkText: "Rapid transport to the Level 2 trauma facility by ground ambulance, using lights and sirens",
                            subBenchmarks: []
                        },
                    ]
                },
                {
                    expectationText: "Perform ongoing patient management and assessment",
                    benchmarks: [
                        {
                            benchmarkText: "Reassess vitals every 5 minutes; repeat primary and secondary survey",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Dress wounds with minor bleeding (e.g., gun shot wound to abdomen)",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Contact receiving facility.  Provide complete report on patient's condition and ETA",
                            subBenchmarks: []
                        },
                    ]
                }
            ]
        },
        {
            step: "R",
            slides: [
                {
                    paragraphs: [
                        para(
                            text("In an idealized scenario, you arrive on scene and find a young man lying on the ground in a parking lot surrounded by police officers and bystanders. Your initial assessment reveals a conscious but lethargic patient who has significant bleeding from a gunshot wound to his left upper anterior mid-thigh despite a bystander holding pressure.")
                        ),
                        para(
                            text("You immediately direct your partner to provide manual c-spine stabilization, while you"),
                            link("apply a tourniquet", "The patient is hemorrhaging from his upper leg, which is an immediate life threat and should be addressed before progressing on with your exam, including before assessing the patient’s ABCs "),
                            text("to the patient’s left upper leg, proximal to the injury, and confirm that this has stopped the bleeding.")
                        )
                    ]
                },
                {
                    paragraphs: [
                        para(
                            text("Next, you find the patient’s airway to be patent but his breathing is rapid and shallow so you assist his ventilations with a"),
                            link("bag valve mask", "This patient was not adequately ventilating (rapid, shallow breaths) so O2 delivered via nasal canula or non-rebreather mask alone would not have been adequate."),
                            text("and turn the O2 up to 15L. His extremity pulses are absent and skin is pale and diaphoretic. You instruct another responder to obtain a set of baseline vitals and obtain a SAMPLE history from a bystander while you perform a rapid head-to-toe assessment.")
                        ),
                        para(
                            text("You and your partners then place the patient"),
                            link("on a scoop stretcher,", "Spinal immobilization is contraindicated in this patient with a penetrating abdominal wound; immobilization on a spine board may cause further injury."),
                            text("cover him with a blanket, and transfer him to the ambulance. Worried for"),
                            link("hemorrhagic shock,", "This GSW victim with a known source of significant bleeding is hypotensive, most likely from hemorrhagic shock, which should be managed with rapid fluid resuscitation, keeping the patient supine, administering O2, and keeping the patient warm"),
                            text("you place two large-bore IVs en route and start fluid resuscitation to a goal systolic BP >90.  You notify the Level 2 trauma center you are on the way, reassess the patient"),
                            link("every five minutes,", "Critically ill patients should be reassessed every 5 minutes"),
                            text("and confirm that all interventions are working properly, modifying any as necessary.")

                        )
                    ]
                }
            ]
        },
        {
            step: "F",
            title: "Formalize learning",
            heading: "Please take a few minutes to think and reply to these questions",
            questions: "What are your key take-home points from this scenario? What is something you want to continue working on or do differently in the future?"
        }
    ];